import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	singleDuplicateDescription: {
		id: 'project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.single-duplicate-description',
		defaultMessage:
			'To avoid duplicate fields appearing twice, the ‘{formField}‘ linked Jira field will be removed from the ‘{formName}’ form. This also affects any other request types using this form.',
		description:
			'The content of the confirmation modal before removing a duplicate Jira field from an attached form.',
	},
	multipleDuplicatesDescription: {
		id: 'project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.multiple-duplicates-description',
		defaultMessage:
			'To avoid duplicate fields appearing twice, the following linked Jira fields will be removed from the ‘{formName}’ form. This also affects any other request types using this form.',
		description:
			'The content of the confirmation modal before removing duplicate Jira fields from an attached form.',
	},
	genericDuplicatesDescription: {
		id: 'project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.generic-duplicates-description',
		defaultMessage:
			'To avoid fields appearing twice, some linked Jira fields will be removed from the ‘{formName}’ form. This also affects any other request types using this form.',
		description:
			'The content of the confirmation modal before removing duplicate Jira fields from an attached form.',
	},
	title: {
		id: 'project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.title',
		defaultMessage: 'Linked Jira fields will be removed from the attached form',
		description:
			'The title of the confirmation modal before removing duplicate Jira fields from an attached form.',
	},
	cancel: {
		id: 'project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.cancel',
		defaultMessage: 'Cancel',
		description: 'The label for the cancel button on the modal.',
	},
	removeField: {
		id: 'project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.remove-field',
		defaultMessage: 'Remove field',
		description: 'The label for the confirm button on the modal with a single duplicate field.',
	},
	removeFields: {
		id: 'project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.remove-fields',
		defaultMessage: 'Remove fields',
		description: 'The label for the confirm button on the modal with multiple duplicate fields.',
	},
	errorRemovingDuplicateFormFields: {
		id: 'project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.error-removing-duplicate-form-fields',
		defaultMessage: 'We couldn’t remove duplicate fields',
		description: 'The title of an error flag when removing duplicate fields from a form.',
	},
	errorRemovingDuplicateFormFieldsDescription: {
		id: 'project-settings-product-features-jsm-common.duplicate-form-linked-fields-warning-dialog.error-removing-duplicate-form-fields-description',
		defaultMessage: 'Try again',
		description: 'The description of an error flag when removing duplicate fields from a form.',
	},
});
